export default     {
  path: '/dashboard/account',
  meta: {
    menuLabel: 'Account',
  },
  components: {
    default: () => import('../../views/memberDashboard/dashboard/index.vue'),
    header: () => import('../../views/memberDashboard/header/index.vue'),
    footer: () => import('../../views/public/footer/index.vue'),
  },
  children: [
    {
      path: 'profile',
      name: 'dashboard.account.profile',
      meta: {
        menuLabel: 'User Profile',
        middleware: {
          mustBeAuthenticated: true,
          mustHasRoles: ['member', 'credential_member']
        }
      },

      component: () => import('@/modules/member/components/account-profile'),
    },
    {
      path: 'payment',
      name: 'dashboard.account.payment',
      meta: {
        menuLabel: 'Payment Details',
        middleware: {
          mustBeAuthenticated: true,
          mustHasRoles: ['member', 'credential_member']
        }
      },

      component: () => import('@/modules/member/components/account-payment'),
    },
    {
      path: 'invoices',
      name: 'dashboard.account.invoices',
      meta: {
        menuLabel: 'Tax Invoices',
        middleware: {
          mustBeAuthenticated: true,
          mustHasRoles: ['member', 'credential_member']
        }
      },

      component: () => import('@/modules/member/components/account-invoices'),
    }
  ]
}
